import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('Visualizations', ['colorPalette', 'primaryColor', 'secondaryColor']),
  },
  async mounted() {
    await this.$store.dispatch('Visualizations/getColorPalette')
  },
}
